module.exports = __webpack_public_path__ + "img/button-style-icon-sample.0f039099.svg";